// Each product's own screens plug into the product routes by name, so they can be added without
// touching the routes (stage 4). A screen is the default export of a file in src/screens/products/:
//
//   <Prefix><Page>.jsx    the screen for 1 page of a product, e.g. FundingEngineHome.jsx,
//                         FundingEngineWeek.jsx, MasterclassHome.jsx, MentorshipActions.jsx,
//                         MastermindHome.jsx, PoytHome.jsx
//   <Prefix>.jsx          the product's screen for any page it has no page screen for, e.g.
//                         Masterclass.jsx; it gets the page in route.page
//
// Prefix, by slug first: Masterclass (/masterclass), FundingEngine (/funding-engine), Poyt (Profit
// On Your Terms, /poyt), Mentorship (the 1-2-1, /mentorship) and OnDemand (Property Cashflow For
// Life, /cashflow). Then by type: a mastermind (the Property Accelerator, /accelerator, and any
// other) takes Mastermind's; a new product of the other types takes its type's (masterclass,
// client_space, on_demand); and a live cohort other than those 2, in any look, takes FundingEngine's
// (the product-types plan, 13 Oct), whose screens read only that product's own rows by its id and
// draw in the product's own look (styles/live-cohort.css re-points The Funding Engine's colours and
// fonts to the frame's, so the looks never mix). Profit On Your Terms is matched by its slug first, so
// it keeps its own screens and never draws The Funding Engine's, and The Funding Engine never draws
// POYT's. Page: Home, Week (also tried as Recording and Module), Sessions, Recordings, Resources,
// Certificate, and a type extra by its key (actions -> Actions, group -> Group, start-here ->
// StartHere). A resource pack has no prefix: its home is its Resources (ProductRoute.jsx candidates).
//
// Where neither file exists the route draws the shared page for it (the recording page, Resources,
// Sessions, Recordings, the certificate) or, for a home, the holding page inside the product's frame.
// An online tool's page (<product path>/tools/<placement id>) is always the shared tool runner
// (ToolPage.jsx), never a product's own screen.

const PREFIX_BY_SLUG = {
  masterclass: 'Masterclass', 'funding-engine': 'FundingEngine', poyt: 'Poyt', mentorship: 'Mentorship', cashflow: 'OnDemand',
}
const PREFIX_BY_TYPE = { masterclass: 'Masterclass', mastermind: 'Mastermind', client_space: 'Mentorship', on_demand: 'OnDemand' }

// Profit On Your Terms and the Accelerator came off their holding pages on 6 Oct (Adam, 5 Oct:
// "build everything first"). The list stays, empty, for any product whose open pages wait again.
// Until a product moves in, its paths still go where it lives now (config/products.js:
// HUB_NOT_MOVED_IN and catalogue.moved_in), before anything here is asked.
export const PHASE_TWO_SLUGS = []

export function prefixFor(product) {
  if (!product || PHASE_TWO_SLUGS.includes(product.slug)) return null
  if (PREFIX_BY_SLUG[product.slug]) return PREFIX_BY_SLUG[product.slug]
  if (product.type === 'live_cohort') return 'FundingEngine'
  return PREFIX_BY_TYPE[product.type] || null
}

const pascal = key => key.split(/[^a-z0-9]+/i).filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('')

// The file names tried for a page, most specific first
export function pageNames(page) {
  if (page === 'week') return ['Week', 'Recording', 'Module']
  if (page === 'home') return ['Home']
  if (page === 'other') return []
  return [pascal(page)]
}

const found = new Map()

// The screen module's default export, or null. Every file in src/screens/ is in the bundle (esbuild
// bundles the folder for this import), so this resolves at once; the answer is kept.
export async function loadScreen(name) {
  if (found.has(name)) return found.get(name)
  let screen = null
  try {
    // the folder is part of the variable, so the import covers every screen in src/screens/ and
    // needs no file in src/screens/products/ to build
    const file = ['products', name].join('/')
    const mod = await import(`../screens/${file}.jsx`)
    screen = typeof mod?.default === 'function' ? mod.default : null
  } catch {
    screen = null
  }
  found.set(name, screen)
  return screen
}

export function knownScreen(name) {
  return found.has(name) ? found.get(name) : undefined
}
